import { combineReducers } from 'redux';

import { apiReducer } from 'utils/reduxUtils';

import {
  INGREDIENTS_FAILURE,
  INGREDIENTS_REQUEST,
  INGREDIENTS_SUCCESS,
  PRESCRIPTION_FAILURE,
  PRESCRIPTION_REQUEST,
  PRESCRIPTION_SUCCESS,
  ROUTINE_FAILURE,
  ROUTINE_REQUEST,
  ROUTINE_SUCCESS,
} from './actionTypes';

const initialState = {
  status: 'idle',
  data: null,
  error: null,
};

const formula = (state = initialState, action) => {
  switch (action.type) {
    default:
      return apiReducer(
        [PRESCRIPTION_REQUEST, PRESCRIPTION_SUCCESS, PRESCRIPTION_FAILURE],
        state,
        action
      );
  }
};
const routine = (state = initialState, action) => {
  switch (action.type) {
    default:
      return apiReducer([ROUTINE_REQUEST, ROUTINE_SUCCESS, ROUTINE_FAILURE], state, action);
  }
};

const ingredients = (state = initialState, action) => {
  switch (action.type) {
    default:
      return apiReducer(
        [INGREDIENTS_REQUEST, INGREDIENTS_SUCCESS, INGREDIENTS_FAILURE],
        state,
        action
      );
  }
};

export default combineReducers({
  formula,
  routine,
  ingredients,
});
